import Vue from 'vue'
import money from 'v-money'

Vue.use(money, {
    decimal: '.',
    thousands: ',',
    prefix: '$',
    precision: 0,
    masked: false
})